import * as React from 'react';
import Link from '@mui/material/Link';
import PlaceIcon from '@mui/icons-material/Place';
import LaunchIcon from '@mui/icons-material/Launch';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid2';

type MapLinkProps = {
  linkUrl: string,
  underline?: "hover" | "always" | "none"
  children?: React.ReactNode;
};


export default function MapLink(linkProps: MapLinkProps) {
  const linkUrl = linkProps.linkUrl;
  const underline = linkProps.underline || "hover";

  return (
    <Link href={linkUrl} 
          underline={underline}
          >
        <Grid sx={{alignItems: "stretch", display: "inline-flex"}} container spacing={2}>
          <Grid size="auto" >
            <Box sx={{height: "100%"}}>
              <PlaceIcon sx={{height: "100%", verticalAlign: "middle", fontSize: 30}} />
            </Box>
          </Grid>
          <Grid 
            size="grow"
          >
            <Box>
              {!!linkProps.children && (
                <>
                {linkProps.children}
                <br />
                </>
              )}
              OPEN IN MAPS&nbsp;<LaunchIcon fontSize='inherit' />
            </Box>
          </Grid>
      </Grid>
    </Link>
  );
}